var _defs, _g, _rect, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInexploreLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 245,
    height: 26,
    viewBox: "0 0 244.92 25.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#D\xE9grad\xE9_sans_nom_9);\n      }\n\n      .cls-3 {\n        fill: url(#D\xE9grad\xE9_sans_nom_6);\n      }\n\n      .cls-4 {\n        fill: url(#D\xE9grad\xE9_sans_nom_7);\n      }\n\n      .cls-5 {\n        fill: url(#D\xE9grad\xE9_sans_nom_4);\n      }\n\n      .cls-6 {\n        fill: url(#D\xE9grad\xE9_sans_nom_5);\n      }\n\n      .cls-7 {\n        fill: url(#D\xE9grad\xE9_sans_nom_2);\n      }\n\n      .cls-8 {\n        fill: url(#D\xE9grad\xE9_sans_nom_3);\n      }\n\n      .cls-9 {\n        fill: url(#D\xE9grad\xE9_sans_nom_8);\n      }\n\n      .cls-10 {\n        fill: #ac53f2;\n      }\n\n      .cls-11 {\n        fill: url(#D\xE9grad\xE9_sans_nom);\n      }\n\n      .cls-12 {\n        fill: url(#D\xE9grad\xE9_sans_nom_19);\n      }\n\n      .cls-13 {\n        fill: url(#D\xE9grad\xE9_sans_nom_18);\n      }\n\n      .cls-14 {\n        fill: url(#D\xE9grad\xE9_sans_nom_13);\n      }\n\n      .cls-15 {\n        fill: url(#D\xE9grad\xE9_sans_nom_10);\n      }\n\n      .cls-16 {\n        fill: url(#D\xE9grad\xE9_sans_nom_12);\n      }\n\n      .cls-17 {\n        fill: url(#D\xE9grad\xE9_sans_nom_15);\n      }\n\n      .cls-18 {\n        fill: url(#D\xE9grad\xE9_sans_nom_11);\n      }\n\n      .cls-19 {\n        fill: url(#D\xE9grad\xE9_sans_nom_17);\n      }\n\n      .cls-20 {\n        fill: url(#D\xE9grad\xE9_sans_nom_14);\n      }\n\n      .cls-21 {\n        fill: url(#D\xE9grad\xE9_sans_nom_16);\n      }\n\n      .cls-22 {\n        fill: url(#D\xE9grad\xE9_sans_nom_20);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 244.92,
    height: 25.45
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom",
    "data-name": "D\\xE9grad\\xE9 sans nom",
    x1: 266.67,
    y1: 827.21,
    x2: 174.48,
    y2: 827.02,
    gradientTransform: "translate(0 -813.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_2",
    "data-name": "D\\xE9grad\\xE9 sans nom 2",
    x1: 266.67,
    y1: 827.27,
    x2: 174.48,
    y2: 827.08,
    gradientTransform: "translate(0 -813.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3",
    "data-name": "D\\xE9grad\\xE9 sans nom 3",
    x1: 266.67,
    y1: 827.25,
    x2: 174.48,
    y2: 827.07,
    gradientTransform: "translate(0 -813.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_4",
    "data-name": "D\\xE9grad\\xE9 sans nom 4",
    x1: 266.67,
    y1: 827.32,
    x2: 174.48,
    y2: 827.13,
    gradientTransform: "translate(0 -813.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_5",
    "data-name": "D\\xE9grad\\xE9 sans nom 5",
    x1: 266.67,
    y1: 827.26,
    x2: 174.48,
    y2: 827.07,
    gradientTransform: "translate(0 -813.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6",
    "data-name": "D\\xE9grad\\xE9 sans nom 6",
    x1: 266.67,
    y1: 827.2,
    x2: 174.48,
    y2: 827.02,
    gradientTransform: "translate(0 -813.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_7",
    "data-name": "D\\xE9grad\\xE9 sans nom 7",
    x1: 266.67,
    y1: 827.22,
    x2: 174.48,
    y2: 827.03,
    gradientTransform: "translate(0 -813.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8",
    "data-name": "D\\xE9grad\\xE9 sans nom 8",
    x1: 266.67,
    y1: 827.18,
    x2: 174.48,
    y2: 827,
    gradientTransform: "translate(0 -813.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9",
    "data-name": "D\\xE9grad\\xE9 sans nom 9",
    x1: 266.67,
    y1: 827.17,
    x2: 174.48,
    y2: 826.98,
    gradientTransform: "translate(0 -813.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10",
    "data-name": "D\\xE9grad\\xE9 sans nom 10",
    x1: 266.67,
    y1: 827.11,
    x2: 174.48,
    y2: 826.92,
    gradientTransform: "translate(0 -813.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_11",
    "data-name": "D\\xE9grad\\xE9 sans nom 11",
    x1: 14.47,
    y1: 19.94,
    x2: 14.47,
    y2: 1.53,
    gradientTransform: "translate(0 25.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0f0136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#16053f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#230b4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#361565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#4d2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#6b31a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8c42cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac53f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_12",
    "data-name": "D\\xE9grad\\xE9 sans nom 12",
    x1: 5.54,
    y1: 13.9,
    x2: 19.26,
    y2: 21.82,
    gradientTransform: "translate(0 25.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13",
    "data-name": "D\\xE9grad\\xE9 sans nom 13",
    x1: 7.89,
    y1: 17.82,
    x2: 24.44,
    y2: 17.82,
    gradientTransform: "translate(0 25.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_14",
    "data-name": "D\\xE9grad\\xE9 sans nom 14",
    x1: 11.66,
    y1: 19.63,
    x2: 26.12,
    y2: 11.27,
    gradientTransform: "translate(0 25.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_15",
    "data-name": "D\\xE9grad\\xE9 sans nom 15",
    x1: 18.12,
    y1: 18.38,
    x2: 18.12,
    y2: 1.84,
    gradientTransform: "translate(0 25.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_16",
    "data-name": "D\\xE9grad\\xE9 sans nom 16",
    x1: 19.92,
    y1: 14.61,
    x2: 11.56,
    y2: 0.15,
    gradientTransform: "translate(0 25.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_17",
    "data-name": "D\\xE9grad\\xE9 sans nom 17",
    x1: 18.99,
    y1: 11.74,
    x2: 4.53,
    y2: 3.38,
    gradientTransform: "translate(0 25.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_18",
    "data-name": "D\\xE9grad\\xE9 sans nom 18",
    x1: 14.91,
    y1: 6.35,
    x2: 0.44,
    y2: 14.71,
    gradientTransform: "translate(0 25.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_19",
    "data-name": "D\\xE9grad\\xE9 sans nom 19",
    x1: 5.76,
    y1: 8.93,
    x2: 13.07,
    y2: 21.58,
    gradientTransform: "translate(0 25.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d0034"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#10063e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#253381"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3557b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4170dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4980f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c86fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_20",
    "data-name": "D\\xE9grad\\xE9 sans nom 20",
    x1: 14.81,
    y1: 15.67,
    x2: 11.99,
    y2: 10.72,
    gradientTransform: "translate(0 25.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ff884d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#c34cd8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7739ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2976ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M30.91,19.55v-10.86c.63-.11,1.28-.16,1.95-.16s1.29.05,1.98.16v10.86c-.63.11-1.29.16-1.98.16-.63,0-1.28-.05-1.95-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M30.8,5.23c-.6-.6-.9-1.3-.9-2.09,0-.38.1-.8.3-1.26s.55-.86,1.05-1.2c.5-.33,1.05-.5,1.64-.5.8,0,1.5.29,2.09.88.6.59.9,1.28.9,2.08s-.3,1.5-.9,2.09c-.6.6-1.3.9-2.09.9s-1.5-.3-2.09-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M45.91,7c.77.26,1.41.63,1.9,1.11.49.47.86,1.04,1.11,1.7s.37,1.37.37,2.15v7.59c-.65.11-1.31.16-1.98.16s-1.31-.05-1.98-.16v-6.96c0-.4-.07-.8-.21-1.2-.14-.39-.4-.7-.79-.91s-.84-.32-1.37-.32c-.17,0-.47.03-.88.09s-.82.21-1.23.43v8.86c-.65.11-1.31.16-1.98.16s-1.28-.05-1.95-.16v-10.86c.4-.37.97-.73,1.7-1.08s1.51-.61,2.35-.77,1.6-.24,2.28-.24c1,0,1.89.13,2.66.39h0v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M63.42,14.28h-8.33c.23,1.71,1.26,2.56,3.08,2.56.54,0,1.1-.09,1.67-.26.57-.18,1.24-.51,2.02-1,.39.3.71.7.96,1.19s.41.98.46,1.48c-1.55,1.18-3.39,1.77-5.54,1.77-.95,0-1.84-.15-2.66-.45-.83-.3-1.54-.73-2.14-1.29-.6-.56-1.06-1.26-1.38-2.08-.32-.83-.49-1.75-.49-2.77,0-.95.16-1.84.49-2.68.32-.84.79-1.56,1.38-2.16.6-.61,1.3-1.07,2.1-1.4.8-.32,1.66-.49,2.57-.49.86,0,1.66.14,2.4.41s1.37.66,1.9,1.16c.53.5.93,1.11,1.21,1.83s.42,1.5.42,2.35c0,.7-.04,1.32-.13,1.85h0v-.02ZM59.83,12.07c0-.47-.1-.91-.29-1.29-.19-.39-.47-.66-.82-.83s-.71-.26-1.08-.28c-.72,0-1.3.22-1.75.66s-.72,1.02-.8,1.74h4.75,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M77.92,19.5c-.09.05-.39.1-.9.14-.51.04-1.04.07-1.58.07-.81,0-1.46-.04-1.95-.11l-2.64-3.85-2.42,3.85c-.6.07-1.21.11-1.85.11-1.07,0-1.88-.07-2.42-.21l4.4-6.2-4.32-6.01c.21-.09.62-.17,1.23-.24.61-.07,1.21-.11,1.81-.11.49,0,.92.03,1.29.08l2.48,3.82,2.35-3.82c.47-.05.95-.08,1.42-.08.39,0,.88.03,1.48.09.6.06,1.04.14,1.32.25l-4.27,6.04,4.59,6.17h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M87.81,7.09c.85.27,1.59.68,2.21,1.23.62.54,1.11,1.23,1.45,2.07s.51,1.79.51,2.86-.18,1.95-.54,2.8c-.36.84-.86,1.56-1.49,2.15s-1.37,1.04-2.2,1.34c-.84.31-1.71.46-2.62.46-.81,0-1.52-.08-2.14-.24v4.64c-.65.11-1.31.16-1.98.16s-1.28-.05-1.95-.16v-15.79c.72-.56,1.6-1.02,2.62-1.38,1.03-.36,2.15-.54,3.36-.54.98,0,1.9.14,2.76.41h0ZM86.25,16.31c.5-.18.92-.53,1.26-1.05.34-.53.51-1.16.51-1.9s-.17-1.34-.51-1.86c-.34-.52-.77-.87-1.29-1.05-.52-.18-1.01-.28-1.46-.28-.62,0-1.2.11-1.77.34v5.75c.46.21,1.06.32,1.82.32.46,0,.94-.09,1.44-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M103.59,19.51c-.84-.31-1.56-.75-2.18-1.33s-1.09-1.29-1.42-2.12c-.33-.84-.5-1.75-.5-2.76s.17-1.89.51-2.72c.34-.83.82-1.54,1.44-2.14.61-.6,1.35-1.05,2.2-1.37.85-.32,1.76-.47,2.73-.47s1.87.16,2.71.47c.84.32,1.57.77,2.19,1.36.61.59,1.09,1.3,1.42,2.14s.5,1.75.5,2.73-.17,1.87-.51,2.7c-.34.84-.82,1.55-1.44,2.14s-1.35,1.04-2.2,1.36c-.85.32-1.76.47-2.73.47s-1.89-.15-2.73-.46h.01ZM108.47,15.77c.52-.62.78-1.45.78-2.46s-.26-1.84-.78-2.46-1.23-.94-2.12-.94-1.61.31-2.14.94-.79,1.44-.79,2.46.26,1.84.79,2.46c.53.62,1.24.94,2.14.94s1.6-.31,2.12-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M123.53,7c-.04,1.37-.4,2.5-1.11,3.4-.44-.12-.94-.18-1.5-.18-.79,0-1.43.12-1.93.37v8.96c-.63.11-1.29.16-1.98.16-.63,0-1.28-.05-1.95-.16v-10.99c.37-.33.87-.66,1.5-.99s1.31-.56,2.04-.71,1.4-.22,2.02-.22c1.16,0,2.13.12,2.9.37h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M133.38,4.84c.37,0,.66-.15.93-.42.27-.27.4-.59.4-.96,0-.27-.08-.52-.23-.75s-.33-.39-.55-.48c-.21-.09-.38-.15-.55-.15h-6.16c-.37,0-.66.15-.93.42s-.4.59-.4.96c0,.27.08.52.23.75s.33.39.55.48c.21.09.38.15.55.15h6.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M136.02,14.28h-8.33c.23,1.71,1.26,2.56,3.08,2.56.54,0,1.1-.09,1.67-.26.57-.18,1.24-.51,2.02-1,.39.3.71.7.96,1.19s.41.98.46,1.48c-1.55,1.18-3.39,1.77-5.54,1.77-.95,0-1.84-.15-2.66-.45-.83-.3-1.54-.73-2.14-1.29-.6-.56-1.06-1.26-1.38-2.08-.32-.83-.49-1.75-.49-2.77,0-.95.16-1.84.49-2.68.32-.84.79-1.56,1.38-2.16.6-.61,1.3-1.07,2.1-1.4.8-.32,1.66-.49,2.57-.49.86,0,1.66.14,2.4.41.74.27,1.37.66,1.9,1.16s.93,1.11,1.21,1.83c.28.72.42,1.5.42,2.35,0,.7-.04,1.32-.13,1.85h0v-.02ZM132.44,12.07c0-.47-.1-.91-.29-1.29-.19-.39-.47-.66-.82-.83s-.71-.26-1.08-.28c-.72,0-1.3.22-1.75.66s-.72,1.02-.8,1.74h4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M93.7,3.62v15.93c.69.11,1.35.16,2,.16.7,0,1.35-.05,1.95-.16V2.94c-1.28.33-2.6.56-3.96.68h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M150.24,11.07c0,.79-.14,1.5-.42,2.13s-.68,1.15-1.19,1.56c-.51.41-1.13.72-1.85.93s-1.5.32-2.36.32h-1.05v3.51c-.51.09-1.09.14-1.74.14s-1.23-.05-1.82-.14V6.89c.61-.12,1.32-.22,2.14-.3.82-.08,1.58-.12,2.26-.12,4.01,0,6.02,1.53,6.02,4.6h.01ZM146.06,12.43c.36-.34.54-.78.54-1.32s-.18-.92-.55-1.22c-.37-.3-.92-.45-1.66-.45l-1.03.02v3.49h1.05c.74,0,1.29-.17,1.65-.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M162.59,19.38c-.67.18-1.71.28-3.12.28l-.77-.02-2.41-4.22h-1.13v4.11c-.51.09-1.09.14-1.74.14s-1.23-.05-1.82-.14V7.04c.62-.12,1.34-.22,2.17-.3.83-.08,1.59-.12,2.29-.12,1.24,0,2.27.15,3.1.45.83.3,1.47.76,1.93,1.36.45.61.68,1.4.68,2.37,0,.85-.18,1.6-.55,2.25-.37.65-.88,1.16-1.52,1.54l2.88,4.78h.01ZM155.17,12.53h1.28c.28,0,.55-.05.83-.15.28-.1.49-.27.64-.5.15-.24.23-.51.23-.83,0-.45-.15-.8-.44-1.07-.3-.26-.72-.39-1.27-.39l-1.26.04v2.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M176.16,19.38c-.88.16-1.66.24-2.33.24-.4,0-.8-.03-1.22-.1l-.75-2.03h-4.44l-.75,2.03c-.47.05-1.01.08-1.62.08-.76,0-1.38-.07-1.85-.22l4.76-12.53c.47-.08,1.08-.12,1.82-.12.68,0,1.26.04,1.74.12l4.66,12.53h-.02ZM170.79,14.54l-.75-2.03-.4-1.26-.38,1.26-.75,2.03h2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185.56,9.98h-3.41v9.53c-.63.1-1.22.16-1.78.16s-1.14-.05-1.78-.16v-9.53h-3.41c-.1-.46-.16-.98-.16-1.56s.05-1.12.16-1.58h10.38c.1.46.16.98.16,1.56s-.05,1.11-.16,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M186.94,19.52V6.89c.51-.09,1.09-.14,1.74-.14s1.22.05,1.82.14v12.63c-.51.09-1.09.14-1.74.14s-1.23-.05-1.82-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.16,19.41c-.84-.32-1.54-.78-2.12-1.38-.58-.6-1.02-1.31-1.32-2.14-.3-.83-.45-1.73-.45-2.7s.16-1.86.48-2.7c.32-.84.78-1.57,1.38-2.17.6-.61,1.32-1.07,2.16-1.4s1.76-.49,2.74-.49c.63,0,1.3.09,1.99.27.7.18,1.35.5,1.95.98-.09.54-.32,1.07-.67,1.6-.35.53-.77.92-1.24,1.18-.59-.42-1.23-.63-1.91-.63-.95,0-1.69.3-2.22.9-.53.6-.8,1.42-.8,2.48s.27,1.85.8,2.46,1.25.92,2.16.92,1.64-.28,2.23-.83c.54.33.97.72,1.28,1.18.32.46.53,1.03.65,1.7-1.05.85-2.5,1.28-4.34,1.28-1,0-1.92-.16-2.75-.48h0v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.55,19.52V6.89c.51-.09,1.09-.14,1.74-.14s1.22.05,1.82.14v12.63c-.51.09-1.09.14-1.74.14s-1.23-.05-1.82-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M219.45,17.94c0,.58-.05,1.11-.16,1.58h-8.8V6.85h8.63c.11.46.16.98.16,1.56s-.05,1.11-.16,1.58h-5.07v1.56h4.5c.1.46.16.98.16,1.56s-.05,1.08-.16,1.54h-4.5v1.74h5.25c.1.46.16.98.16,1.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.88,6.89v12.59c-1.08.2-2.23.25-3.45.16l-4.07-6.18-.45-.81.1,1.01v5.86c-.71.09-1.31.14-1.8.14-.37,0-.95-.05-1.76-.14V6.94c.43-.12.99-.19,1.66-.22.67-.02,1.27-.01,1.8.04l4.07,6.44.45.81-.1-1.01v-6.12c.6-.09,1.18-.14,1.74-.14.62,0,1.22.05,1.82.14h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M237.85,19.66c-.68-.11-1.3-.29-1.88-.54-.57-.25-1.04-.52-1.39-.81.04-.61.2-1.17.48-1.7s.63-.92,1.06-1.16c.45.32,1.02.58,1.71.8s1.39.33,2.1.33c.55,0,.95-.05,1.19-.16s.37-.26.37-.47c0-.29-.17-.51-.5-.66-.34-.15-.96-.35-1.89-.58-1.13-.28-1.98-.61-2.55-.99s-.97-.82-1.2-1.32-.35-1.06-.35-1.68.12-1.21.36-1.74.6-.97,1.06-1.34c.46-.37,1.01-.65,1.66-.84.64-.19,1.35-.29,2.11-.29.51,0,1.07.05,1.68.15.61.1,1.16.26,1.68.48.51.22.92.45,1.22.69-.04.58-.2,1.14-.47,1.67-.28.53-.65.94-1.13,1.21-.37-.26-.84-.49-1.42-.67s-1.19-.28-1.84-.28c-.47,0-.84.06-1.1.17-.26.11-.39.27-.39.46,0,.05,0,.13.03.22.02.09.13.2.32.32.2.12.93.33,2.19.63,1.4.34,2.39.83,3,1.46.6.63.92,1.41.95,2.33,0,.71-.09,1.35-.32,1.91-.22.57-.56,1.04-1,1.41-.44.38-.98.66-1.62.86s-1.35.3-2.14.3c-.66,0-1.32-.06-2-.17h.02Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 5.99,
    y: 5.19,
    width: 16.96,
    height: 14.38
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M17.91,1.75c-1.54-.31-3.15-.19-4.63.38-1.07.4-2.08,1.04-2.95,1.9-.18.18-.35.36-.5.55-.81.96-1.36,2.05-1.67,3.21h0c-.25.96-.33,1.93-.25,2.9h0c.07.75.24,1.5.52,2.21h0c.21.58.5,1.13.84,1.66.3.45.66.89,1.06,1.29s.85.76,1.31,1.06c-.62-.13-1.22-.32-1.78-.58h0c-.7-.31-1.35-.72-1.93-1.21-.74-.62-1.37-1.37-1.86-2.21-.6-1.03-.99-2.2-1.09-3.45-.02-.24-.04-.49-.04-.74,0-1.22.26-2.38.74-3.43.64-1.44,1.68-2.66,2.99-3.53,1.33-.88,2.92-1.4,4.63-1.4s3.3.51,4.63,1.4h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M24.44,8.28c-.87-1.31-2.09-2.35-3.53-2.99h0c-1.04-.48-2.21-.74-3.43-.74-.25,0-.5.01-.75.04-1.25.11-2.41.5-3.44,1.09-.84.49-1.59,1.12-2.21,1.86h0c-.49.59-.9,1.24-1.21,1.94h0c-.25.56-.45,1.15-.57,1.77-.11.54-.16,1.09-.16,1.65s.05,1.12.16,1.65c-.35-.53-.63-1.08-.84-1.65h0c-.28-.72-.45-1.46-.52-2.21h0c-.08-.98,0-1.95.25-2.9h0c.3-1.16.86-2.25,1.67-3.21.16-.19.32-.37.5-.55.87-.87,1.87-1.5,2.95-1.9,1.48-.57,3.09-.69,4.63-.38,1.56.31,3.04,1.07,4.24,2.28,1.21,1.21,1.97,2.69,2.28,4.24h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M24.44,17.52c.31-1.54.19-3.14-.38-4.62h0c-.41-1.08-1.04-2.08-1.9-2.95-.18-.18-.36-.35-.55-.5-.96-.81-2.06-1.36-3.21-1.67-.94-.25-1.93-.33-2.9-.25-.75.07-1.5.24-2.21.52h0c-.57.21-1.13.5-1.65.84-.46.3-.89.66-1.3,1.06-.4.41-.75.84-1.06,1.3.13-.62.32-1.21.57-1.77h0c.31-.7.72-1.36,1.21-1.94h0c.61-.74,1.37-1.37,2.21-1.86,1.03-.6,2.2-.98,3.44-1.09.24-.02.5-.04.75-.04,1.22,0,2.38.26,3.43.73h0c1.44.65,2.66,1.69,3.53,3h0c.88,1.33,1.4,2.92,1.4,4.63s-.51,3.3-1.4,4.62h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M24.44,17.52h0c-.31,1.56-1.07,3.04-2.28,4.25-1.21,1.21-2.69,1.96-4.24,2.28,1.3-.87,2.34-2.09,2.98-3.53h0c.48-1.05.74-2.21.74-3.43,0-.25-.01-.5-.04-.75-.11-1.25-.5-2.41-1.09-3.44-.49-.85-1.12-1.59-1.87-2.21-.58-.49-1.23-.9-1.93-1.21h0c-.56-.26-1.15-.45-1.77-.58-.54-.11-1.09-.16-1.65-.16s-1.12.05-1.65.16c.52-.35,1.07-.63,1.65-.84h0c.72-.28,1.46-.45,2.21-.52.97-.08,1.95,0,2.9.25,1.15.3,2.25.86,3.21,1.67.19.16.37.32.55.5.87.87,1.5,1.87,1.9,2.94h0c.57,1.49.69,3.09.38,4.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M21.64,17.09c0,1.22-.26,2.38-.74,3.43h0c-.64,1.44-1.68,2.66-2.98,3.53h0c-1.33.88-2.92,1.4-4.63,1.4s-3.3-.51-4.62-1.4c1.53.31,3.14.19,4.61-.38h0c1.07-.4,2.08-1.04,2.94-1.9.18-.18.35-.36.5-.55.81-.96,1.36-2.06,1.67-3.21.25-.94.33-1.93.25-2.9-.07-.75-.24-1.5-.52-2.21h0c-.21-.57-.49-1.12-.84-1.64h0c-.3-.47-.66-.9-1.06-1.31-.4-.4-.84-.75-1.29-1.06.62.13,1.21.32,1.77.57h0c.7.32,1.36.73,1.93,1.22.75.62,1.38,1.37,1.87,2.21.6,1.03.99,2.2,1.09,3.44.02.24.04.5.04.75h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M18.39,18.01c-.3,1.15-.86,2.25-1.67,3.21-.16.19-.32.37-.5.55-.87.87-1.87,1.5-2.94,1.9h0c-1.47.57-3.08.69-4.61.38h0c-1.56-.31-3.04-1.07-4.24-2.28-1.21-1.21-1.96-2.69-2.28-4.24.87,1.3,2.09,2.34,3.53,2.98h0c1.04.48,2.21.74,3.43.74.25,0,.5-.01.74-.04,1.25-.11,2.42-.49,3.45-1.09.85-.49,1.59-1.12,2.21-1.87.49-.58.9-1.23,1.21-1.93.26-.56.45-1.16.58-1.78.11-.53.16-1.08.16-1.64s-.05-1.11-.16-1.64c.35.52.63,1.07.84,1.64h0c.28.72.45,1.47.52,2.22.08.97,0,1.95-.25,2.9h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M17.29,14.55c-.13.62-.32,1.22-.58,1.78-.31.7-.72,1.36-1.21,1.93-.62.75-1.37,1.38-2.21,1.87-1.03.6-2.2.98-3.45,1.09-.24.02-.49.04-.74.04-1.22,0-2.38-.26-3.43-.74h0c-1.44-.64-2.66-1.68-3.53-2.98h0c-.88-1.33-1.4-2.93-1.4-4.63s.51-3.3,1.4-4.63c-.31,1.54-.19,3.14.38,4.62h0c.4,1.08,1.04,2.08,1.9,2.95.18.18.36.35.55.5.96.81,2.05,1.36,3.21,1.67.95.25,1.93.33,2.9.25.75-.07,1.5-.24,2.21-.52.57-.21,1.12-.49,1.64-.84.46-.3.9-.66,1.3-1.06s.76-.84,1.06-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M14.93,16.91c-.52.35-1.07.63-1.64.84-.72.28-1.46.45-2.21.52-.97.08-1.95,0-2.9-.25-1.15-.3-2.24-.86-3.21-1.67-.19-.16-.37-.32-.55-.5-.87-.87-1.5-1.87-1.9-2.94h0c-.57-1.49-.69-3.09-.38-4.63.31-1.56,1.07-3.04,2.28-4.24,1.21-1.21,2.69-1.97,4.24-2.28-1.31.87-2.35,2.09-2.99,3.53-.48,1.04-.74,2.21-.74,3.43,0,.25.01.5.04.74.11,1.25.49,2.42,1.09,3.45.49.84,1.12,1.59,1.86,2.21.59.49,1.23.9,1.93,1.21h0c.56.26,1.16.45,1.78.58.53.11,1.08.16,1.64.16s1.11-.05,1.64-.16h.02Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 13.28,
    cy: 12.9,
    r: 3.18
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInexploreLogoWhite);
export default __webpack_public_path__ + "static/media/inexplore-logo-white.8926da6909a582e62674aeba9310ea7f.svg";
export { ForwardRef as ReactComponent };